module.exports = __webpack_public_path__ + "static/media/frontend.857df080.jpg";